import { ReactNode, useEffect, useEffectEvent } from "react";

import { CadClickUiControls } from "@plansoft-configuration-renderer/components";

type Settings = Array<{ name: string; value: string }>;

type Format = string | { "2d": string; "3d": string };

type CcExportEventProps = {
  format: Format;
  settings: Settings;
  activeControl?: HTMLElement & {
    application: CadClickUiControls & {
      exportFileName: string | null;
      zipFileName: string | null;
      generateExportFileName: () => void;
    };
    format: Format;
    settings: Settings;
  };
};

export function CadBoxExportFileName(): ReactNode {
  const handleExportFileNameChange = useEffectEvent((event: Event) => {
    const control = event.target as (HTMLElement & CcExportEventProps) | null;

    if (control == null) {
      console.warn(
        "CadBoxExportFileName: Event target is not an HTMLElement. Export file name override will not work.",
      );
      return;
    }

    if (control.activeControl == null) {
      console.warn(
        "CadBoxExportFileName: No active control found on event target. Export file name override will not work.",
      );
      return;
    }

    console.log(control.tagName, control.activeControl.tagName, {
      format: control.activeControl.format,
    });

    const uiControlsInstance = control.activeControl.application;

    if (uiControlsInstance == null) {
      console.warn(
        "CadBoxExportFileName: No CadClick UI Controls instance found. Export file name override will not work.",
      );
      return;
    }

    switch (control.activeControl.tagName) {
      case "CC-DIMENSIONAL-DRAWING": {
        uiControlsInstance.exportFileName = "dimsheet";
        uiControlsInstance.zipFileName = "dimsheets";
        break;
      }

      case "CC-DOWNLOAD-2D": {
        uiControlsInstance.exportFileName = "export-2d";
        break;
      }

      case "CC-DOWNLOAD-3D": {
        uiControlsInstance.exportFileName = "export-3d";
        break;
      }

      default: {
        uiControlsInstance.exportFileName = null;
        uiControlsInstance.zipFileName = null;
        uiControlsInstance.generateExportFileName();
        break;
      }
    }
  });

  useEffect(() => {
    window.addEventListener(
      "onDownloadButtonClick",
      handleExportFileNameChange,
    );
    return () => {
      window.removeEventListener(
        "onDownloadButtonClick",
        handleExportFileNameChange,
      );
    };
  }, []);

  return null;
}
